import { ArticleType } from '../../../domain/articleType';
import { CategoryItem } from '../../types';
import { buildArticlesURLObject, slugIt } from '../links';

export function toArticleCategoryItems(categories: string[], articleType: ArticleType = ArticleType.GUIDE): CategoryItem[] {
  return categories.map((category) => ({
    id: slugIt(category),
    label: category,
    urlObject: buildArticlesURLObject({
      category,
    }, articleType),
  }));
}
